import { FormViewField } from 'components/FormView';

export const filterOptions = {
    formName: 'SalesInvoiceEnquiryFilterRow',
    validate: null,
    rowModelType: 'serverSide',
    parameters: [
      {
          id: 0,
          type: 'EX_LOOKUP_FIELD',
          props: {
              label: 'Entity view',
              name: 'View',
              lookupName: 'EntityView',
              size: 'medium',
              required: true
          }
      },
      {
          id: 1,
          type: 'EX_LOOKUP_FIELD',
          props: {
            label: 'Sales entity',
            size: 'medium',
            name: 'Entity',
            lookupName: 'SalesEntity',
            disabled: false,
            isEntityScoped: true,
            suppressDescription: true
          }
      },
      {
        id: 2,
        type: 'EX_LOOKUP_FIELD',
        props: {
          label: 'Customer',
          name: 'CustomerId',
          lookupName: 'Customer',
          placeholder: '',
          required: false,
          size: 'medium',
          searchScreenAPIParms: { Type: 'LOOKUP' }
        }
      },
      {
          id: 3,
          type: 'TEXT_FIELD',
          props: {
            label: 'Customer P/O',
            name: 'CustomerPO',
            placeholder: '',
            size: 'medium',
          },
      },
      {
          id: 4,
          type: 'DATE_FIELD',
          props: {
            label: 'Date range from',
            name: 'FromDate',
            required: false,
            dateFormat: 'DD/MM/YYYY',
            placeholder: 'DD/MM/YYYY',
            nullable: 'true',
            size: 'medium',
            style: {
              display: 'inline-block',
              width: '155px',
              marginRight: '16px'
            }
          }
      },
      {
          id: 5,
          type: 'DATE_FIELD',
          props: {
            label: 'To',
            name: 'ToDate',
            required: false,
            dateFormat: 'DD/MM/YYYY',
            placeholder: 'DD/MM/YYYY',
            nullable: 'true',
            size: 'medium',
            style: {
              display: 'inline-block',
              width: '155px'
            }
          }
      },
      {
          id: 6,
          type: 'AUTOCOMPLETE_FIELD',
          props: {
            label: 'Document type',
            name: 'DocumentType',
            required: false,
            options: [
              {
                value: 'al',
                label: 'Invoices & CR/Notes'
              },
              {
                value: 'in',
                label: 'Invoices'
              },
              {
                value: 'cn',
                label: 'Credit Note'
              },
            ]
          }
      },
      {
        id: 7,
        type: 'SELECT_FIELD',
        props: {
          label: 'Finalised/Unfinalised',
          name: 'Finalised',
          options: [
            {
              value: false,
              label: 'Unfinalised',
              default: true
            },
            {
              value: true,
              label: 'Finalised'
            }
          ]
        }
      },
    ] as FormViewField[]
  };
